// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"b28ce8bbd3c81a8f","node_modules_canvg_lib_index_es_js":"4bd9d76ba21d7952"}[chunkId] + ".js";
};